const PRIMARY_FIELD_WEIGHT = 1.0;
const SECONDARY_FIELD_WEIGHT = 0.6;
const STARTSWITH_SCORE = 3.0;
const EXACT_SCORE = 3.5;
const CONTAINS_SCORE = 1.0;
const CURRENT_VIEW_BOOST = 1.5;
// The backend matched these rows (on fields we don't see — customer name on a
// contact, a description, a zip); keep them, below every visible match.
const BACKEND_MATCH_FLOOR = 0.1;
function matchType(fieldValue, term) {
  if (!fieldValue) return 0;
  const v = String(fieldValue).toLowerCase();
  const t = term.toLowerCase();
  if (v === t) return EXACT_SCORE;
  if (v.startsWith(t)) return STARTSWITH_SCORE;
  if (v.includes(t)) return CONTAINS_SCORE;
  return 0;
}
export function scoreRow(row, term, entityConfig, entityKey, currentEntity) {
  let best = 0;
  const fields = entityConfig.fields || [];
  fields.forEach((fieldName, idx) => {
    const weight = idx === 0 ? PRIMARY_FIELD_WEIGHT : SECONDARY_FIELD_WEIGHT;
    const score = matchType(row[fieldName], term) * weight;
    if (score > best) best = score;
  });
  if (currentEntity && entityKey === currentEntity) best *= CURRENT_VIEW_BOOST;
  return best;
}

// Ranked list in DISPLAY order: grouped by source (`order`, then any other
// source in the order its group was built), best score first within a group.
// The search bar renders and arrow-keys through this same order.
export function rankResults(groups, term, currentEntity, order = []) {
  const ranked = [];
  const keys = Object.keys(groups);
  const groupIndex = key => {
    const i = order.indexOf(key);
    return i > -1 ? i : order.length + keys.indexOf(key);
  };
  for (const [entityKey, data] of Object.entries(groups)) {
    const config = data.config;
    const rows = data.rows || [];
    for (const row of rows) {
      const score = config.synthetic ? 1.0 : Math.max(scoreRow(row, term, config, entityKey, currentEntity), BACKEND_MATCH_FLOOR);
      const label = typeof config.label === 'function' ? config.label() : config.label;
      ranked.push({
        entityKey,
        label,
        row,
        score,
        config
      });
    }
  }
  ranked.sort((a, b) => groupIndex(a.entityKey) - groupIndex(b.entityKey) || b.score - a.score);
  return ranked;
}

// The single best match regardless of group (Enter with nothing selected).
export function bestResult(ranked) {
  return (ranked || []).reduce((best, r) => !best || r.score > best.score ? r : best, null);
}
export default rankResults;